import { render, staticRenderFns } from "./settings-nav.vue?vue&type=template&id=483cb5a6&scoped=true&"
import script from "./settings-nav.vue?vue&type=script&lang=js&"
export * from "./settings-nav.vue?vue&type=script&lang=js&"
import style0 from "./settings-nav.vue?vue&type=style&index=0&id=483cb5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483cb5a6",
  null
  
)

export default component.exports